import axios from 'axios';

import type { IGenericUserSuggestedUpdateClass } from '@bb/users';
import type { AxiosRequestBuilder } from '@/app-package';

export interface IGetSuggestionsForUserParams {
  userId: string;
}
export declare type IGetSuggestionsForUserRequest = AxiosRequestBuilder<
  IGetSuggestionsForUserParams,
  'get'
>;
export declare type IGetSuggestionsForUserResponse =
  IGenericUserSuggestedUpdateClass[];

const getSuggestionsForUser = async (params: IGetSuggestionsForUserParams) => {
  const url = `/suggested_user_update/${params.userId}`;

  const config: IGetSuggestionsForUserRequest = { url, method: 'get' };

  const { data } = await axios.request<IGetSuggestionsForUserResponse>(config);

  return data;
};

export default getSuggestionsForUser;
